import { toast } from 'react-toastify';
import firebase from '../config/firebase';
import { setUserProfileData } from './firestoreService';

export function firebaseObjectToArray(snapshot) {
	if (snapshot) {
		return Object.entries(snapshot).map((elem) =>
			Object.assign({}, elem[1], { id: elem[0] })
		);
	}
}

export function signInWithEmail(creds) {
	return firebase.auth().signInWithEmailAndPassword(creds.email, creds.password);
}

export function signOutFirebase() {
	return firebase.auth().signOut();
}

export async function registerInFirebase(creds) {
	try {
		const result = await firebase
			.auth()
			.createUserWithEmailAndPassword(creds.email, creds.password);
		await result.user.updateProfile({ displayName: creds.displayName });
		return await setUserProfileData(result.user);
	} catch (error) {
		throw error;
	}
}

export async function socialLogin(selectedProvider) {
	let provider;
	if (selectedProvider === 'facebook') {
		provider = new firebase.auth.FacebookAuthProvider();
	}
	if (selectedProvider === 'google') {
		provider = new firebase.auth.GoogleAuthProvider();
	}
	try {
		const result = await firebase.auth().signInWithPopup(provider);
		if (result.additionalUserInfo.isNewUser) {
			await setUserProfileData(result.user);
		}
	} catch (error) {
		toast.error(error.message);
	}
}

export function updateUserPassword(creds) {
	const user = firebase.auth().currentUser;
	return user.updatePassword(creds.newPassword1);
}

export function addEventChatComment(eventId, values) {
	const user = firebase.auth().currentUser;
	const newComment = {
		displayName: user.displayName,
		photoURL: user.photoURL,
		uid: user.uid,
		text: values.comment,
		date: Date.now(),
		parentId: values.parentId
	};
	return firebase.database().ref(`chat/${eventId}`).push(newComment);
}

export function getEventChatRef(eventId) {
	return firebase.database().ref(`chat/${eventId}`).orderByKey();
}
